import { ActionReducer, ActionReducerMap } from '@ngrx/store'
import { localStorageSync } from 'ngrx-store-localstorage'
import { reducer as authReducer, deserialize } from './auth.reducer'
import * as botReducer from './bot.reducer'
import * as deskReducer from './desk.reducer'
import { State } from './index'
import { reducer as infrastructureReducer } from './infrastructure.reducer'
import * as organizationReducer from './organization.reducer'
import { reducer as tasksReducer } from './tasks.reducer'
import { reducer as templateUsageReducer } from './template-usage.reducer'
import { reducer as templatesReducer } from './templates.reducer'
import { reducer as userSettingsReducer } from './user-settings.reducer'
import { reducer as usersReducer } from './users.reducer'

export const reducers: ActionReducerMap<State> = {
  infrastructure: infrastructureReducer,
  auth: authReducer,
  bot: botReducer.reducer,
  desk: deskReducer.reducer,
  organization: organizationReducer.reducer,
  tasks: tasksReducer,
  templates: templatesReducer,
  users: usersReducer,
  userSettings: userSettingsReducer,
  templateUsage: templateUsageReducer,
}

export function localStorageSyncReducer(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return localStorageSync({
    keys: [
      { auth: { deserialize } },
      'userSettings',
      'templateUsage',
      // { bot: { deserialize: botReducer.deserialize } },
      // { desk: { deserialize: deskReducer.deserialize } },
      // { organization: { deserialize: organizationReducer.deserialize } },
      // { tasks: { deserialize: deserializeTasks } },
      // { users: { deserialize: deserialiseUsers } },
    ],
    rehydrate: true,
  })(reducer)
}
